module.exports = __webpack_public_path__ + "images/yunnan_banner02.jpg?a596a30c8788557efd26a432e79d897c";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/yunnan_banner02.jpg
// module id = 213
// module chunks = 1